// 洞洞杂货铺 · 常见问题数据
export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    id: "what-is",
    question: "洞洞杂货铺漫画到底是什么？",
    answer:
      "洞洞杂货铺是一部围绕「洞洞」这一核心概念展开的奇幻漫画。故事发生在一间看似普通、却藏有无数神秘洞洞的杂货铺里，通过店主与各色客人的相遇，一步步揭开洞洞背后的世界观与谜题。它兼具治愈的日常感和深邃的奇幻设定，是近年备受考据党喜爱的一部作品。",
  },
  {
    id: "dongdong-meaning",
    question: "「洞洞」到底是什么意思？",
    answer:
      "「洞洞」在作品中是一个多层隐喻。表面上是货架、墙壁上那些小小的孔洞，深层则代表记忆的裂隙、时空的交汇点，以及人与人之间看不见的联系。洞洞既是通往其他世界的入口，也是串联整部漫画核心谜题的关键设定。",
  },
  {
    id: "where-read",
    question: "在哪里可以阅读这部漫画？",
    answer:
      "你可以通过主流漫画阅读平台搜索「洞洞杂货铺」在线阅读。本站定位为作品的世界观与设定解析站，不提供漫画正片内容，而是帮助读者更好理解这部作品背后的世界观、角色关系与隐藏线索。",
  },
  {
    id: "read-order",
    question: "应该按照什么顺序阅读、理解它的世界观？",
    answer:
      "建议先读本站的世界观解析页了解「洞洞」的基本含义，再看角色图鉴熟悉主要人物与关系，最后翻阅设定百科按需查阅具体条目。这样能循序渐进地把分散在作品各处的设定线索串联起来，避免遗漏关键伏笔。",
  },
  {
    id: "inspiration",
    question: "这部作品的世界观灵感来源是什么？",
    answer:
      "从设定来看，洞洞杂货铺融合了「阈限空间」「记忆迷宫」「无限杂货铺」等经典奇幻母题，又叠加了温暖治愈的日常细节。这种「奇幻外壳 + 人间温情」的组合，正是其世界观既深邃又打动人心的原因所在。",
  },
  {
    id: "update",
    question: "网站的解析内容会持续更新吗？",
    answer:
      "会的。每当漫画更新新的章节，我们都会第一时间整理其中出现的新设定、新角色与新的隐藏线索，并同步更新到对应的解析页面，帮助读者追更时不被伏笔绕晕。",
  },
];